module.exports = __webpack_public_path__ + "static/media/real_estate.3c3f7705.svg";